import { CatalogResourceType } from "@evergis/api";
import { FileType } from "../../../../modules/FeatureCard/components/Attributes/components/Attachments/types";

export const getResourceColor = (fileType: FileType, resourceType?: CatalogResourceType) => {
  if (resourceType === CatalogResourceType.Table) {
    return null;
  }

  switch (fileType) {
    case FileType.LINES:
      return "rgba(255, 152, 0, 0.06)";
    case FileType.POINTS:
      return "rgba(0, 186, 186, 0.06)";
    case FileType.POLYGON:
      return "rgba(63, 163, 16, 0.06)";
    case FileType.RASTER:
      return "rgba(70, 87, 231, 0.06)";
    case FileType.TABLE:
      return "rgba(106, 211, 173, 0.06)";
    case FileType.WMS:
      return "rgba(122, 0, 218, 0.06)";
    case FileType.ARCGIS:
      return "rgba(0, 154, 242, 0.06)";
    case FileType.XYZ:
      return "rgba(111, 150, 0, 0.06)";
    case FileType.PostreSQL:
      return "rgba(0, 170, 255, 0.06)";
    case FileType.ArcGISMapServer:
      return "rgba(0, 121, 193, 0.06)";
    case FileType.ArcGISFeatureServer:
      return "rgba(97, 189, 101, 0.06)";
    default:
      return null;
  }
};
